import React from 'react';
import { TableCell, TableRow, TextField, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Icon from '../../../components/Icon/Icon';

export default function RaceRowRunner({ runner, race, i, onChange }: any) {
  const { t } = useTranslation('common');

  return (
    <TableRow key={ runner.id + race.id } className="add-meeting-form__expanded">
      <TableCell className="add-meeting-form__cell" colSpan={ 3 }>
        <div className="add-meeting-form__container">
          <span className="add-meeting-form__number">{ i + 1  }</span>
          <TextField
            placeholder={ `${ t('addMeetingForm.runners') } ${ i + 1 }` }
            variant="outlined"
            className="add-meeting-form__input add-meeting-form__input--full-width"
            name="numberRaces"
            type="text"
            value={ race.runners[i]?.name }
            onChange={ (e) => onChange('name', i, race, e.target.value) }
            required
          />
        </div>
      </TableCell>
      <TableCell className="add-meeting-form__cell" colSpan={ 3 }>
        <div className="add-meeting-form__container">
          <Checkbox
            name="checkBoxSelected"
            color="primary"
            className="add-meeting-form__icon"
            icon={ <Icon icon="checkboxSmall" className="add-meeting-form__icon" /> }
            checked={ race.runners[i]?.nonRunner }
            onChange={ () => onChange('nonRunner', i, race, !race.runners[i]?.nonRunner) }
            checkedIcon={
              <Icon
                icon="checked"
                className="add-meeting-form__icon"
              />
            }
          />
          <span className="add-meeting-form__runner">Non runner</span>
        </div>
      </TableCell>
      <TableCell colSpan={ 2 } />
    </TableRow>
  );
}
